import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_PRODUCTION_PROGRESS',
    url: '',
  });

  const fetchData = function () {
    if (param) {
      let url = '/api/product/progress';
      Object.keys(param).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${param[key]}`;
      });
      exec(url);
    }
  };
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [isRequestSuccessed, data || [], fetchData];
});
